/*
 * @Author: zhan lin sen 
 * @Date: 2020-03-27 15:36:25
 * @LastEditTime: 2020-03-27 15:50:07
 * @LastEditors: Please set LastEditors
 * @Description: 注册全局toast组件
 * @FilePath: \trunk\src\components\toast.js
 */

import Toast from './Toast.vue';
import Vue from 'vue';

const ToastConstructor = Vue.extend(Toast); //使用基础 Vue 构造器，创建一个“子类”
let instance;
const initInstance = () => {
    instance = new ToastConstructor(); // 创建toast组件
    document.body.appendChild(instance.$mount().$el); // 挂载到页面
};

Vue.prototype.$toast = (content) => {
    if (!instance) { 
        initInstance();
    }
    
    if (typeof content == 'string') {
        instance.message = content;
    } else {
        instance.message = content.message;
        instance.ok = function() { // 点击确定关闭组件
            instance.show = false;
            content.ok()
        }
    }
    instance.show = true;
}
Toast.install = Vue => { // 注册toast组件
    Vue.component(Toast.name, Toast)
}
export default Toast;